
import axiosInstance from './api';

export const createReport = (reportData) => axiosInstance.post('/reports', reportData);

export const getAllReports = () => axiosInstance.get('/reports');

export const getReportById = (id) => axiosInstance.get(`/reports/${id}`);

export const updateReport = (id, updateData) => axiosInstance.patch(`/reports/${id}`, updateData);

export const deleteReport = (id) => axiosInstance.delete(`/reports/${id}`);

export const replyToReport = (id, reply) =>
  axiosInstance.patch(`/reports/${id}/reply`, { reply });
